<template>
  <div v-if="rows && rows.length">
    <div
      class="edit_app_info flex flex--top"
      v-for="(info, index) in rows"
      :key="index"
    >
      <div class="edit_app_info1 mobile_only">
        {{ `${info.side} | ${info.diagnosis_name} ` }}
      </div>
      <div class="edit_app_info1 no_mobile desk-flex">
        <div class="surg_list-1">{{ info.side }}</div>
        <div class="surg_list-3">{{ info.diagnosis_name }}</div>
        <div class="surg_list-3">{{ info.diagnosis_number }}</div>
        <div class="surg_list-5">{{ info.notice }}</div>
      </div>
      <div class="edit_app_info2 flex flex--end">
        <a
          class="edit_pen svg-block"
          href="javascript:void(0)"
          @click="$emit('editSelectedBlock', index)"
        >
          <PenSvg />
        </a>
        <a
          class="edit_close_sur"
          href="javascript:void(0);"
          @click.prevent="$emit('removeSelectedBlock', index)"
        >
          <CloseSvg />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import PenSvg from "@/assets/img/svg/ic-pen.svg";
import CloseSvg from "@/assets/img/svg/close.svg";

export default {
  name: "PastDiagnosisInfo",
  props: {
    rows: { required: true }
  },
  components: { PenSvg, CloseSvg }
};
</script>
